var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-return",on:{"click":_vm.prevStep}},[_c('font-awesome-icon',{staticClass:"button-return-icon",attrs:{"icon":"angle-double-left"}}),_c('span',[_vm._v("Regresar")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }